import { render, staticRenderFns } from "./ShiftsList.vue?vue&type=template&id=50a7bc0a&scoped=true&"
import script from "./ShiftsList.vue?vue&type=script&lang=js&"
export * from "./ShiftsList.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsList.vue?vue&type=style&index=0&id=50a7bc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7bc0a",
  null
  
)

export default component.exports